import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingPaymentFreeTrial',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/free-trial/',
    component: () =>
      import('@/modules/free-trial-pricing/layout/LayoutPage.vue'),
    children: [
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/free-trial-pricing/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
